module.exports = __webpack_public_path__ + "media/bootstrap-icons/star-fill-8dba13f8.svg";